export default __webpack_public_path__ + "static/media/head01_en_sp.554f5516.png";